import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

// "Eligible for Disposal" table — reuses GET /assets (all statuses); the
// Dispose button is hidden once status is DISPOSED. Backend still enforces
// the real eligibility rule (no active allocation / no open service) at
// submit time via a 409 if genuinely ineligible.
export const fetchEligibleAssets = createAsyncThunk("fetchEligibleAssets", async ({ page = 1, limit = 20 }) => {
	const params = new URLSearchParams({ page, size: limit });
	const response = await axiosHttp.get(`assets?${params}`);
	const data = response.data?.data ?? response.data;
	return { docs: data.content ?? [], total: data.total };
});

// "Disposal History" table — real backend endpoint: GET /assets/disposal-list
// (added by backend team, mirrors GET /assets/services/all for Service records).
export const fetchDisposalHistory = createAsyncThunk("fetchDisposalHistory", async ({ page = 1, limit = 50 } = {}) => {
	const params = new URLSearchParams({ page, size: limit });
	const response = await axiosHttp.get(`assets/disposal-list?${params}`);
	const data = response.data?.data ?? response.data;
	return { docs: data.content ?? [], total: data.total };
});

const DisposalListSlice = createSlice({
	name: "disposalListSlice",
	initialState: {
		eligibleAssets: { isLoading: false, docs: [], total: 0, error: null },
		history: { isLoading: false, docs: [], total: 0, error: null },
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchEligibleAssets.pending, (state) => {
				state.eligibleAssets.isLoading = true;
			})
			.addCase(fetchEligibleAssets.fulfilled, (state, action) => {
				state.eligibleAssets.isLoading = false;
				state.eligibleAssets.docs = action.payload.docs;
				state.eligibleAssets.total = action.payload.total;
			})
			.addCase(fetchEligibleAssets.rejected, (state, action) => {
				state.eligibleAssets.isLoading = false;
				state.eligibleAssets.error = action.payload;
			})

			.addCase(fetchDisposalHistory.pending, (state) => {
				state.history.isLoading = true;
			})
			.addCase(fetchDisposalHistory.fulfilled, (state, action) => {
				state.history.isLoading = false;
				state.history.docs = action.payload.docs;
				state.history.total = action.payload.total;
			})
			.addCase(fetchDisposalHistory.rejected, (state, action) => {
				state.history.isLoading = false;
				state.history.error = action.payload;
			});
	},
});

export default DisposalListSlice.reducer;
